import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=bedbf6a2&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"
import style0 from "./Main.vue?vue&type=style&index=0&id=bedbf6a2&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bedbf6a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/ap/jenkins/workspace/prod-ykd360-admin-front(医可达旧管理端)/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bedbf6a2')) {
      api.createRecord('bedbf6a2', component.options)
    } else {
      api.reload('bedbf6a2', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=bedbf6a2&scoped=true", function () {
      api.rerender('bedbf6a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/system/main/Main.vue"
export default component.exports